import { useBulkCreateRestsList } from './hooks/useBulkCreateRestsList'
import { useBulkDeleteRestsList } from './hooks/useBulkDeleteRestsList'
import { useFetchRest } from './hooks/useFetchRest'
import { postRest } from './rest.api'

class RestService {
  bulk = {
    useCreateList: useBulkCreateRestsList,
    useDeleteList: useBulkDeleteRestsList
  }

  api = {
    postRest,
    useFetchRest
  }
}

export const restService = new RestService()

export type { RestSchema } from './types/Rest.schema'

export type { BulkDeleteRestsListOptions } from './rest.api'
